module.exports = __webpack_public_path__ + "img/error-code.3af8b034.png";